import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';
import { OrgService } from 'src/app/service/org.service';
import { CoursesService } from 'src/app/service/courses.service';
import { AcademicsService } from 'src/app/service/academics.service';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { AttendanceService } from 'src/app/service/attendance.service';
import { DatePipe } from '@angular/common'
import { ScoresService } from 'src/app/service/scores.service';
@Component({
  selector: 'app-warning-letter-update',
  templateUrl: './warning-letter-update.component.html',
  styleUrls: ['./warning-letter-update.component.scss']
})
export class WarningLetterUpdateComponent implements OnInit {
  showLoader: boolean = false;
  updating: boolean = false;
  highlightColors: any = [];
  courses: any = [];
  letterTypes: any = [];
  allstudents: any = [];
  teachers: any = [];
  yearId: any;
  semesterId: any;
  batchId: any;
  // groupId: any;
  studentId: any;
  teacherId: any;
  examScoreFile: any;
  examScoreFileName: any;
  orgId: any;
  username: any;
  letterId: any;
  typeId: any;

  warningLetterUpdateForm = new FormGroup({
    warntypeid: new FormControl('', [
      Validators.required,
    ]),
    studentid: new FormControl('', [
      Validators.required,
    ]),
    subjectid: new FormControl('', [
      Validators.required,
    ]),
    teacherid: new FormControl('', [
      Validators.required,
    ]),
    remarks: new FormControl('', [
      // Validators.required,
    ]),
    active: new FormControl('', [
      Validators.required,
    ])
  });

  constructor(
    // private userService: UserService,
    private scoresService: ScoresService,
    private toastrService: ToastrService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private academicsService: AcademicsService
    , private roleService: RoleService
    , private orgService: OrgService
    , private datePipe: DatePipe
    , private enrollmentGroupService: EnrollmentGroupService
    , private attendance: AttendanceService,
  ) {

  }

  ngOnInit(): void {
    this.orgId = this.globals.currentUserInfo.orgid;
    this.username = this.globals.currentUserInfo.username;
    this.showLoader = true;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.yearId = params['yearId'] || "";
        this.semesterId = params['semesterId'] || "";
        this.batchId = params['batchId'] || "";
        // this.groupId = params['groupId'] || "";
        this.studentId = params['studentId'] || "";
        this.letterId = params['letterId'] || "";
        this.typeId = params['typeId'] || "";


        console.log(this.yearId);
        console.log(this.semesterId);
        console.log(this.batchId);
        if (this.yearId != "" && this.semesterId != "" && this.batchId != "" && this.letterId != "") {
          // if (this.groupId == "") {
          //   this.groupId = 0;
          // }
          if (this.studentId == "") {
            this.studentId = 0;
          }
          if (this.letterId == "") {
            this.letterId = 0;
          }
          if (this.typeId == "") {
            this.typeId = 0;
          }
          this.getWarningLetterById(this.letterId);

        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.router.navigate(['/scores-grades/warning-letters']);
        }
      });
  }

  getWarningLetterById(letterId: number) {
    this.showLoader = true;
    this.scoresService.getWarrningLetterById(this.letterId).subscribe(
      data => {
        console.log(data);
        this.warningLetterUpdateForm.controls.warntypeid.setValue(data.warntypeid);
        this.warningLetterUpdateForm.controls.studentid.setValue(data.studentid);
        this.warningLetterUpdateForm.controls.subjectid.setValue(data.subjectid);
        this.warningLetterUpdateForm.controls.teacherid.setValue(data.teacherid);
        this.warningLetterUpdateForm.controls.remarks.setValue(data.remarks);
        this.warningLetterUpdateForm.controls.active.setValue(data.active);
        // this.getAllCourses();
        this.getBatchCourses(this.batchId);
      },
      error => {
        this.showLoader = false;
        this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      }
    );
  }
  getBatchCourses(batchId: number) {
    this.showLoader = true;
    this.enrollmentGroupService.getBatchSubjects(this.orgId, batchId)
      .subscribe(
        data => {
          this.courses = data;
          this.getStudentsByBatch();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getStudentsByBatch() {
    if (this.yearId && this.semesterId && this.batchId) {
      this.scoresService.getGradeStudents(this.orgId, this.yearId, this.semesterId, this.batchId)
        .subscribe(
          data => {
            this.allstudents = data;
            this.getLetterTypes();
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.allstudents = [];
    }
  }
  // getStudentsByGroup() {
  //   this.attendance.getStudentsByGroup(this.orgId, this.yearId, this.semesterId, this.groupId)
  //     .subscribe(
  //       data => {
  //         this.allstudents = data;
  //         this.getLetterTypes();
  //       },
  //       error => {
  //         this.allstudents = [];
  //         this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
  //       }
  //     );
  // }

  getLetterTypes() {
    //this.letterTypes = [];
    console.log("innnnnnnnnn");
    this.scoresService.getAllWLetterTypes()
      .subscribe(
        data => {
          console.log("innnnnnnnnn2");
          this.letterTypes = data;
          this.getTeachersByCourse();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
    this.showLoader = false;
  }

  getTeachersByCourse() {
    this.teachers = [];
    let courseId = this.warningLetterUpdateForm.controls.subjectid.value;
    if (courseId) {
      this.academicsService.getTeacherCourseBycourseAndType(this.orgId, courseId, "PRIMARY")
        .subscribe(
          data => {
            if (data && data.length) {
              this.teachers = data;
            }else{
              this.warningLetterUpdateForm.controls.teacherid.reset();
            }

          },
          error => {

            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
            // this.showLoader = false

          },
          // () => this.showLoader = false
        );
    }else{
      this.warningLetterUpdateForm.controls.teacherid.reset();
    }

  }
  warningLetterUpdateFormChange() {
    // let classHours = this.createType.controls.classHours.value;
    // let clinicalHours = this.createType.controls.clinicalHours.value;
    // this.createType.controls.totalHours.setValue(Number(classHours) + Number(clinicalHours));
  }

  warningLetterUpdateFormSubmit() {
    if (this.warningLetterUpdateForm.valid) {
      console.log(this.warningLetterUpdateForm.value);
      this.updateWarningLetter(this.warningLetterUpdateForm.value);
    }
    else {
      this.warningLetterUpdateForm.markAllAsTouched();
      this.warningLetterUpdateForm.markAsDirty();
    }
  }

  updateWarningLetter(scoreData: string) {
    this.updating = true;
    let username = this.globals.currentUserInfo.username;
    this.scoresService.updateWarrningLetter(username, this.letterId, 10, scoreData, this.yearId, this.semesterId, this.batchId)
      .subscribe(
        data => {
          console.log(data);
          if (data.sts == "SUCCESS") {
            if (this.globals.lang == "ar") {
              this.toastrService.success(data.arMsg);
            } else {
              this.toastrService.success(data.enMsg);
            }

            this.router.navigate(['/scores-grades/warning-letters'], { queryParams: { yearId: this.yearId, semesterId: this.semesterId, batchId: this.batchId, studentId: this.studentId, typeId: this.typeId } });
          } else {
            if (this.globals.lang == "ar") {
              this.toastrService.error(data.arMsg);
            } else {
              this.toastrService.error(data.enMsg);
            }
          }
          this.updating = false;
        },
        error => {
          this.updating = false;
          this.toastrService.error(this.translate.instant('FAIL_TO_UPDATE'));
        }
      );
  }

  // getBatchCourses(batchId: number) {
  //   this.showLoader = true;
  //   this.enrollmentGroupService.getBatchSubjects(this.orgId, batchId)
  //     .subscribe(
  //       data => {
  //         this.courses = data;
  //         this.getStudentsByGroup();
  //         // Get teachers
  //         this.getTeachersByCourse();
  //       },
  //       error => {
  //         this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
  //       }
  //     );
  // }

  // getStudentsByGroup() {
  //   this.attendance.getStudentsByGroup(this.orgId, this.yearId, this.semesterId, this.groupId)
  //     .subscribe(
  //       data => {
  //         this.allstudents = data;
  //         this.getLetterTypes();
  //       },
  //       error => {
  //         this.allstudents = [];
  //         this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
  //       }
  //     );
  // }

  // getLetterTypes() {
  //   this.letterTypes = [];
  //   let courseId = this.warningLetterUpdateForm.controls.course.value;
  //   console.log("Course Id: " + courseId);

  //   // Test data

  //   this.letterTypes = [
  //     {
  //       id: 1,
  //       nameAr: 'test1 ar',
  //       nameEn: 'test1 en',
  //     },
  //     {
  //       id: 2,
  //       nameAr: 'test2 ar',
  //       nameEn: 'test2 en',
  //     },
  //     {
  //       id: 3,
  //       nameAr: 'test3 ar',
  //       nameEn: 'test3 en',
  //     }
  //   ];
  //   this.showLoader = false;
  //   // this.enrollmentGroupService.getBatchSubjects(this.orgId, batch)
  //   //   .subscribe(
  //   //     data => {
  //   //       this.courses = data;
  //   //     },
  //   //     error => {
  //   //       this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
  //   //     }
  //   //   );
  // }

  // getTeachersByCourse() {
  //   let courseId = this.warningLetterUpdateForm.controls.course.value;
  //   this.academicsService.getTeacherCourseBycourseAndType(this.orgId, courseId, "PRIMARY")
  //     .subscribe(
  //       data => {
  //         if (data && data.length) {
  //           this.teachers = data;
  //         }

  //       },
  //       error => {

  //         this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
  //         // this.showLoader = false

  //       },
  //       // () => this.showLoader = false
  //     );
  //   console.log("Get Teacher by course ... >> ID: " + courseId);
  //   // this.teachers = [
  //   //   {
  //   //     id: 1,
  //   //     nameAr: 'test1 ar',
  //   //     nameEn: 'test1 en',
  //   //   },
  //   //   {
  //   //     id: 2,
  //   //     nameAr: 'test2 ar',
  //   //     nameEn: 'test2 en',
  //   //   },
  //   //   {
  //   //     id: 3,
  //   //     nameAr: 'test3 ar',
  //   //     nameEn: 'test3 en',
  //   //   }
  //   // ];
  // }


  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }

  changeactive() { }


}


